import type { PasswordPolicy } from '@bldsoft/cappie/api/wbs'

import { PasswordPolicyName } from '@setplex/tria-api'

/* This values probably could be parsed from regexp,
 * but it seems better pass it from b.e. as number
 */
export const PASSWORD = {
  [PasswordPolicyName.DEFAULT]: {
    MAX_LENGTH: 64,
    MIN_LENGTH: 6,
  },
  [PasswordPolicyName.STRONG]: {
    MAX_LENGTH: 64,
    MIN_LENGTH: 8,
  },
}

export type ParsedPolicy = {
  name: PasswordPolicyName
  pattern: string
  min: number
  max: number
}

export type ReadyPolicy = {
  name: PasswordPolicyName
  regex: RegExp
  min: number
  max: number
}

export type ContentWithPolicy =
  | { passwordPolicy?: PasswordPolicy | null }
  | undefined
  | null

export const FROM = {
  FEATURES: '/features',
  ACCOUNT: '/account',
  ACCOUNT_INITIATE: '/account/password/initiate',
} as const
export type FROM = (typeof FROM)[keyof typeof FROM]

export const DEFAULT_PASSWORD_REGEX = /^[A-Za-z0-9@#$_&\-*!?.]+$/

export const DEFAULT_POLICY: ReadyPolicy = {
  name: PasswordPolicyName.DEFAULT,
  regex: DEFAULT_PASSWORD_REGEX,
  min: PASSWORD[PasswordPolicyName.DEFAULT].MIN_LENGTH,
  max: PASSWORD[PasswordPolicyName.DEFAULT].MAX_LENGTH,
}
